import type { StyleObj } from '../../@types';
import type { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';

const DEFAULT_STYLES: StyleObj = {
  root: {
    backgroundColor: 'background.paper',
    borderColor: 'neutral.500',
    boxShadow: '0 12px 32px rgba(0, 0, 0, 0.28)',
  },
  header: {},
  iconBadge: {
    backgroundColor: 'primary.900',
    color: 'primary.light',
  },
  title: {},
  description: {
    color: 'neutral.100',
  },
  statusGroup: {},
  statusLabel: {
    color: 'neutral.200',
  },
  statusChip: {
    backgroundColor: 'neutral.600',
    border: '1px solid',
    borderColor: 'neutral.400',
  },
  statusText: {
    color: 'neutral.25',
  },
};

const NEOBET_STYLES: StyleObj = {
  root: {
    backgroundColor: 'neutral.600',
    borderColor: 'divider',
    boxShadow: 'none',
  },
  header: {},
  iconBadge: {
    backgroundColor: 'action.hover',
    color: 'primary.main',
  },
  title: {
    color: 'neutral.25',
  },
  description: {
    color: 'text.secondary',
  },
  statusGroup: {},
  statusLabel: {
    color: 'text.secondary',
  },
  statusChip: {
    backgroundColor: 'transparent',
    border: 'none',
    px: 0,
  },
  statusText: {
    color: 'text.primary',
  },
};

export const KYC_VERIFICATION_CARD_SKIN_STYLES: SkinStylesMap<StyleObj> = {
  [SKIN.BET365]: DEFAULT_STYLES,
  [SKIN.GOLA]: DEFAULT_STYLES,
  [SKIN.NEOBET]: NEOBET_STYLES,
};

export const KYC_VERIFICATION_ACCOUNT_SECTION_SKIN_STYLES = KYC_VERIFICATION_CARD_SKIN_STYLES;
